import React, { useContext } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import "../scss/style.scss";
import AuthContext from "../app/utils/authProvider";
import AuthService from "../app/redux/services/authService";
import AuthAxios from "./helpers/AxiosAuth";
import Swal from "sweetalert2";

import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./utils/appInsights";
import Cookies from "universal-cookie";
import BuSelectionPage from "./containers/loginFlow/BuSelectionPage";
import MedicareSSORedirect from "./containers/ssoLoginFlow/MedicareSSORedirect";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from "react-toastify";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Page404 = React.lazy(() => import("./components/page404/Page404"));
const Page500 = React.lazy(() => import("./components/page500/Page500"));
const Login = React.lazy(() => import("./components/login/Login"));
const ServerLogin = React.lazy(() => import("./auth/ServerLoginPage"));
const ServerLogoutPage = React.lazy(() => import("./auth/ServerLogoutPage"));
//const Home = React.lazy(() => import("./components/home/home"));
const ErrorPage = React.lazy(() => import("./components/home/ErrorPage"));
const Terms = React.lazy(() => import("./components/login/Terms"));
const Privacy = React.lazy(() => import("./components/login/Privacy"));
const Ccpa = React.lazy(() => import("./components/login/Ccpa"));

const SigninOidc = React.lazy(() =>
  import("./components/login/sigin-Callback")
);
const SignoutOidc = React.lazy(() =>
  import("./components/login/signout-Callback")
);
const SilentSigninOidc = React.lazy(() =>
  import("./components/login/silent-Callback")
);
const cookies = new Cookies();

const App = (mainProps) => {
  const auth = useContext(AuthContext);
  AuthAxios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error?.response?.status === 401) {
        Swal.fire({
          text: "Your current session has expired, please login again.",
          icon: "info",
          allowOutsideClick: false,
        }).then((res) => {
          if (res.isConfirmed) {
            localStorage.clear();
            sessionStorage.clear();
            refreshCacheAndReload();
            window.location = cookies.get("client_url") + "/signout-oidc";
          }
        });
      }
      return Promise.reject(error);
    }
  );
  AuthAxios.interceptors.request.use(function (config) {
    var token = "";
    const accesstoken = JSON.parse(
      localStorage.getItem(
        `oidc.user:${process.env.REACT_APP_AUTH_AUTHORITY_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`
      )
    );

    if (accesstoken) {
      token = accesstoken.access_token;
    }
    const reftoken = localStorage.getItem("ref_token");

    config.headers.Authorization = token ? `Bearer ${token}` : "";
    config.headers.Ref_Token = reftoken ? `${reftoken}` : "";

    return config;
  });
  const refreshCacheAndReload = () => {
    if (caches) {
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
      });
    }
    window.location.reload(true);
  };
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <AuthContext.Provider value={AuthService}>
        <BrowserRouter>
          <React.Suspense fallback={loading}>
            <ToastContainer />
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                render={(props) => <Login {...props} />}
              />
              <Route
                exact
                path="/serverlogin"
                name="Login Page"
                render={(props) => <ServerLogin {...props} />}
              />
              <Route
                exact
                path="/bu"
                name="Bu Selection Page"
                render={(props) => <BuSelectionPage {...props} />}
              />
              <Route
                exact
                path="/medicareRedirect"
                name="MedicareRedirect"
                render={(props) => <MedicareSSORedirect {...props} />}
              />
              <Route
                exact
                path="/logout"
                name="Logout Page"
              >
                <ServerLogoutPage />
              </Route>
              <Route
                exact
                path="/signin-oidc"
                name="Login Page"
                render={(props) => <SigninOidc {...props} />}
              />
              {/* <Route
              exact
              path="/home"
              name="Home Page"
              render={(props) => <Home {...props} />}
            /> */}
              <Route
                exact
                path="/error"
                name="Home Page"
                render={(props) => <ErrorPage {...props} />}
              />
              <Route
                exact
                path="/terms"
                name="Terms and Conditions"
                render={(props) => <Terms {...props} />}
              />
               <Route
                exact
                path="/privacy"
                name="Privacy Policy"
                render={(props) => <Privacy {...props} />}
              />
               <Route
                exact
                path="/privacy-ccpa"
                name="Rights And Choices"
                render={(props) => <Ccpa {...props} />}
              />
              <Route
                exact
                path="/signout-oidc"
                name="Login Page"
                render={(props) => <SignoutOidc {...props} />}
              />
              <Route
                exact
                path="/silent"
                name="Login Page"
                render={(props) => <SilentSigninOidc {...props} />}
              />
              <Route
                exact
                path="/404"
                name="Page 404"
                render={(props) => <Page404 {...props} />}
              />
              <Route
                exact
                path="/500"
                name="Page 500"
                render={(props) => <Page500 {...props} />}
              />
              <Route
                path="/"
                name="Dashboard"
                render={(props) => <TheLayout {...props} />}
              />
            </Switch>
          </React.Suspense>
        </BrowserRouter>
      </AuthContext.Provider>
    </AppInsightsContext.Provider>
  );
};

export default App;
